import cloneDeep from 'lodash/cloneDeep';
import { select } from 'redux-saga/effects';
import { DATASET } from '@utils/constants';
import { widgetsSelector } from '@store/overviewDashboard/base/selectors';
import { INVERTED_METRIC_SWITCH_MAP } from '@utils/metrics';

export const query = {
  type: 'group-by',
  dataset: DATASET,
  metrics: [], // append metric name selected in metrics panel
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  granularity: 'ALL',
  filter: [],
  limit: 25,
  groupBy: [
    '', // dimension name
  ],
  orderBy: 'desc',
  sortBy: [{ metric: 'Plays', order: 'desc' }],
  options: {
    withTotals: true,
    withOverviewThresholds: true,
    kpiConfig: {},
  },
};

const initialState = {
  dimension: '',
  query: null,
  response: null,
  isFetching: true,
  errorCode: 0,
  errorMsg: '',
  sort: 0,
  invalid: true,
};

export const buildDimensionQuery = ({ dimension, columns, filter, interval, kpiConfig }) => {
  // unit toggle metrics
  const invertedMetrics: any = [];
  columns.forEach((m) => {
    if (m in INVERTED_METRIC_SWITCH_MAP) {
      invertedMetrics.push(INVERTED_METRIC_SWITCH_MAP[m]);
    }
  });

  const q = {
    ...cloneDeep(query),
    interval,
    filter,
    metrics: [...columns, ...invertedMetrics],
    groupBy: [dimension],
  };
  q.options.kpiConfig = kpiConfig;
  // sory by first metric (plays, ended plays...)
  q.sortBy[0].metric = q.metrics[0];
  return q;
};

export const createDimension = (dimension) => ({
  ...cloneDeep(initialState),
  dimension,
});

export function* getDimensionWidget(widgetIndex) {
  const widgets = yield select(widgetsSelector);
  const dimensionWidget = widgets[widgetIndex];
  return dimensionWidget.config;
}
